import React from "react";
import { LinearProgress, Box, Typography } from "@mui/material";

export const DETECTION_TASK_STATUSES = {
  CREATING: "CREATING",
  PENDING: "PENDING",
  STARTED: "STARTED",
  INPROGRESS: "INPROGRESS",
  FAILED: "FAILED",
  COMPLETED: "COMPLETED",
};

const statusProgressMap = {
  CREATING: 25,
  PENDING: 50,
  STARTED: 60,   // new status
  INPROGRESS: 75,
  COMPLETED: 100,
  FAILED: 100,
};

const statusColorMap = {
  CREATING: "primary",
  PENDING: "warning",
  STARTED: "info",
  INPROGRESS: "info",  // changed from hex
  COMPLETED: "success",
  FAILED: "error",
};


const ProgressBar = ({ status }) => {
  status = status ? status.toUpperCase().replace(' ','') : null;
  const progress = statusProgressMap[status] || 0;
  const color = statusColorMap[status] || "inherit";

//   console.log("Status in ProgressBar:", status,progress,color);

  return (
    <>
      {!status || status === "FAILED" ? (
        <>
          <Typography variant="body2" color={color}>
            {!status
              ? "Not Started"
              : status.charAt(0) + status.slice(1).toLowerCase()}
          </Typography>
        </>
      ) : (
        <Box
          sx={{ width: "100%", display: "flex", flexDirection: "column", gap: 1 }}
        >
          {(status === "CREATING" ||
            status === "PENDING" ||
            status === "STARTED" || // added here
            status === "INPROGRESS" ||
            status === "COMPLETED") && (
            <Typography variant="body2" color="text.secondary">
              {status == null
                ? "Not Started"
                : status.charAt(0) + status.slice(1).toLowerCase()}
            </Typography>
          )}
          <LinearProgress
            variant="determinate"
            value={progress}
            color={color}
          />
        </Box>
      )}
    </>
  );
};

export default ProgressBar;
